import {
  HttpEvent,
  HttpEventType,
  HttpInterceptorFn,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { tap, catchError } from 'rxjs/operators';
import { ConnectionStatusService } from '@services/connection-status.service';
import { environment } from '@environments/environment';
import { Observable, throwError } from 'rxjs';

export const dataSourceInterceptor: HttpInterceptorFn = (
  req,
  next,
): Observable<HttpEvent<unknown>> => {
  const connectionStatus = inject(ConnectionStatusService);
  const isCaisseApiUrl = req.url.startsWith(environment.caisseApiUrl);

  if (!isCaisseApiUrl) {
    return next(req);
  }

  return next(req).pipe(
    tap((event: HttpEvent<unknown>) => {
      if (event.type === HttpEventType.Response) {
        const response = event as HttpResponse<unknown>;
        if (response.headers.get('X-Data-Source') === 'offline') {
          connectionStatus.setOffline();
        } else {
          connectionStatus.setOnline();
        }
      }
    }),
    catchError((error: HttpErrorResponse): Observable<HttpEvent<unknown>> => {
      if (error.headers.get('X-Data-Source') === 'offline') {
        connectionStatus.setOffline();
      } else {
        connectionStatus.setOnline();
      }
      return throwError(() => error);
    }),
  );
};
